import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../../config/axios";
import { GetPaymentAndTransactionRequest } from "../useGetPaymentAndTransaction";

interface IPostRequestToReportQueueType {
    reportType: number;
    filters: Array<any>;
}

async function postRequestReportForTransactionList(data: IPostRequestToReportQueueType): Promise<any> {
    try {
        return (await axiosInstance.post("/Transaction/AddTransactionReportRequest", data)).data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function usePostRequestReportToQueue() {
    return useMutation<any, Error, IPostRequestToReportQueueType>(
        (variables) => postRequestReportForTransactionList(variables)
    );
}